import * as React from "react";

import "./fullPageLoadingBanner.less";

export function FullPageLoadingBanner() {
  return <div id="loading-banner" style={{ position: "fixed", height: "100%", width: "100%", zIndex: 99 }}></div>;
}
